import i18n from '@/plugins/i18n';
import moment from 'moment';
var dt = new Date();
export const forms = [
    {
        type: 'select',
        name: 'stock',
        title: 'Stok',
        rules: {required: true},
        options: {
            data: [],
            labels: ['barcode', 'name'],
            label: 'name',
            search: true,
            track: 'id'
        },
        modal: ['product_id'],
        data: ['product_id',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'movement_type',
        title: 'Stok Tipi',
        rules: {required: true},
        options: {
            data: [],
            label: 'Description',
            track: 'ID'
        },
        modal: ['type_id'],
        data: ['type_id',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'warehouse',
        title: 'Depo',
        rules: {required: true},
        options: {
            data: [],
            label: 'name',
            track: 'id'
        },
        modal: ['warehouse_id'],
        data: ['warehouse',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'radio',
        name: 'movementStatus',
        title: 'Hareket Durumu',
        default: 'customer',
        rules: {},
        options: {
            type: 'locale',
            data: [
                {text: 'Müşteriye Hareket', value: 'customer'},
                {text: 'Depoya Hareket', value: 'warehouse'},
            ],
        },
        modal: [''],
        data: [''],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'customer',
        title: 'Müşteri',
        connectField: 'movementStatus',
        connectFieldValue: ['customer'],
        rules: {required: true},
        options: {
            data: [],
            label: 'name',
            search: true,
            track: 'ID'
        },
        modal: ['customer_id'],
        data: ['customer_id',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'to_warehouse',
        title: 'Hedef Depo',
        connectField: 'movementStatus',
        connectFieldValue: ['warehouse'],
        rules: {required: true},
        options: {
            data: [],
            label: 'name',
            search: true,
            track: 'id'
        },
        modal: ['to_warehouse_id'],
        data: ['to_warehouse',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'date',
        name: 'date',
        title: 'Tarih',
        format:'YYYY-MM-DD',
        default: moment(dt).format('YYYY-MM-DD'),
        rules: {},
        modal: ['date'],
        data: ['date'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'text',
        name: 'amount',
        title: 'Adet',
        rules: {required: true, numeric: true, min_value:1},
        modal: ['quantity'],
        data: ['quantity'],
        additionalButton: false,
        checkBox: false
    },
  
    {
        type: 'tags',
        name: 'serials',
        title: 'Seri No',
        addBtnText: 'Ekle',
        beforeField: 'amount',
        placeHolder: 'Seri numaralarını ayırmak için boşluk veya virgül kullanın',
        default: [],
        rules: {required: true},
        seperator: ' ,;',
        modal: ['product_serial_numbers'],
        data: ['product_serial_numbers'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'textarea',
        name: 'desc',
        title: 'Açıklama',
        rules: {required: false},
        modal: ['description'],
        data: ['description'],
        additionalButton: false,
        checkBox: false
    },

 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/ERP/Stock/forms/movement.js